import type { MatchResult } from "../app/types";
import { deathCopy } from "../app/match-result";
import { Dialog } from "./Dialog";
import { Icon } from "./Icon";

export function ResultDialog({
  result,
  onRestart,
  onHome,
}: {
  readonly result: MatchResult;
  readonly onRestart: () => void;
  readonly onHome: () => void;
}) {
  const completedByTime = result.deathReason === "time";
  const endless = result.mode === "endless";
  return (
    <Dialog labelledBy="result-title" className="result-dialog">
      <div className="result-emblem">
        <Icon
          name={endless ? "infinity" : completedByTime ? "trophy" : "spark"}
        />
      </div>
      <p className="dialog-kicker">
        {endless ? "ENDLESS DRIFT" : "SIGNAL DRIFT"} · 航程回顾
      </p>
      <h2 id="result-title">
        {endless ? "航程已结束" : completedByTime ? "航程已完成" : "线迹已熄灭"}
      </h2>
      <p className="dialog-copy">
        {deathCopy[result.deathReason]}。
        {endless
          ? "休息一下，随时开启下一段漫游。"
          : completedByTime
            ? "这一程，你把微光留到了最后。"
            : "每一次转身，都是下一局的灵感。"}
      </p>
      <div className="result-highlight">
        <span>{endless ? "会话时长" : "本局信号"}</span>
        <strong>
          {endless ? `${(result.sessionMs / 1000).toFixed(1)}s` : result.score}
        </strong>
        <span className="result-rank">
          最终排名 <b>#{result.finalRank}</b>
        </span>
      </div>
      <div className="result-grid">
        <div className="result-stat">
          <span>最大长度</span>
          <strong>{result.maxLength}</strong>
        </div>
        <div className="result-stat">
          <span>{endless ? "死亡次数" : "存活时间"}</span>
          <strong>
            {endless
              ? result.deaths
              : `${(result.survivalMs / 1000).toFixed(1)}s`}
          </strong>
        </div>
        <div className="result-stat">
          <span>造成淘汰</span>
          <strong>{result.eliminations}</strong>
        </div>
        <div className="result-stat">
          <span>拾取微光</span>
          <strong>{result.foodCollected}</strong>
        </div>
      </div>
      {result.assisted ? (
        <p className="assist-result-notice" role="status">
          本局曾启用 LEO ASSIST，不计入正式纪录与外观解锁。
        </p>
      ) : null}
      <div className="dialog-actions">
        <button className="primary-button" onClick={onRestart}>
          <Icon name="play" />
          再来一局
          <Icon name="arrow" />
        </button>
        <button className="secondary-button" onClick={onHome}>
          返回首页
        </button>
      </div>
    </Dialog>
  );
}
